export var ESendCodeType;
(function (ESendCodeType) {
    ESendCodeType[ESendCodeType["login"] = 1] = "login";
    ESendCodeType[ESendCodeType["changepwd"] = 2] = "changepwd";
    ESendCodeType[ESendCodeType["register"] = 3] = "register";
    ESendCodeType[ESendCodeType["add"] = 5] = "add";
    ESendCodeType[ESendCodeType["reregister"] = 6] = "reregister";
    ESendCodeType[ESendCodeType["unbindWechat"] = 10] = "unbindWechat";
    ESendCodeType[ESendCodeType["bindWechat"] = 18] = "bindWechat";
    ESendCodeType[ESendCodeType["smsBusinessDelete"] = 20] = "smsBusinessDelete";
    ESendCodeType[ESendCodeType["virtual"] = 99] = "virtual";
})(ESendCodeType || (ESendCodeType = {}));
